"use client";

import { Category, NewsFeed } from "@model/news/shape";
import {
    createContext,
    useContext,
    useState,
    ReactNode,
    Dispatch,
    SetStateAction,
} from "react";

interface NewsContext {
    newsFeedContext: NewsFeed | null;
    setNewsFeedContext: Dispatch<SetStateAction<NewsFeed | null>>;
    categoriesContext: Category[];
    setCategoriesContext: Dispatch<SetStateAction<Category[]>>;
    swiperSlideIndex: number;
    setSwiperSlideIndex: Dispatch<SetStateAction<number>>;
    continuationToken: string;
    setContinuationToken: Dispatch<SetStateAction<string>>;
}

const NewsContext = createContext<NewsContext | undefined>(undefined);

export const NewsProvider = ({ children }: { children: ReactNode }) => {
    const [newsFeedContext, setNewsFeedContext] = useState<NewsFeed | null>(
        null,
    );
    const [categoriesContext, setCategoriesContext] = useState<Category[]>([]);
    const [swiperSlideIndex, setSwiperSlideIndex] = useState<number>(0);
    const [continuationToken, setContinuationToken] = useState<string>("");

    return (
        <NewsContext.Provider
            value={{
                newsFeedContext,
                setNewsFeedContext,
                categoriesContext,
                setCategoriesContext,
                swiperSlideIndex,
                setSwiperSlideIndex,
                continuationToken,
                setContinuationToken,
            }}
        >
            {children}
        </NewsContext.Provider>
    );
};

// Custom hook to access user context
export const useNewsContext = () => {
    const context = useContext(NewsContext);
    if (!context) {
        throw new Error(
            "useNewsContext must be used within a NewsContextProvider",
        );
    }
    return context;
};
